// Lib
import { isEmpty as isEmptyLd } from 'lodash/fp';

// Utils
import { isEmpty } from '../../../../../../../common/utils/immutableHelper';

// Types
import { AiToolState, AiLocalAiConversation } from './aiToolStateTypes';

export const getCurrentConversation = (state: AiToolState) => state.conversations[state.currentConversationId];
export const getCurrentConversationChosenPromptShortcuts = (state: AiToolState) =>
    getCurrentConversation(state)?.selectedPromptShortcuts || [];

export const isCurrentConversationStarted = (state: AiToolState) => {
    const currentConversation = getCurrentConversation(state);

    if (!currentConversation) return false;

    return currentConversation.selectedPromptShortcuts.length > 1 || !isEmpty(currentConversation.results);
};

/**
 * Determines if the state currently has any history.
 */
export const hasAiHistory = (state: AiToolState) => {
    const allConversations = Object.values(state.conversations);
    return allConversations.some((conversation: AiLocalAiConversation, index: number) => {
        if (index === 0 && conversation.results.length === 0) return false;
        return true;
    });
};

export const getFirstConversation = (state: AiToolState) => Object.values(state.conversations)[0];

/**
 * Determines if the top conversation is empty.
 */
export const isEmptyNewConversation = (state: AiToolState) => {
    const firstConversation = getFirstConversation(state);
    return firstConversation?.results.length === 0;
};

/**
 * Determines if the currently selected conversation is a new conversation without results.
 */
export const isCurrentConversationNewAndEmpty = (state: AiToolState) => {
    const currentConversation = getCurrentConversation(state);

    if (!currentConversation) return false;

    if (!isEmptyLd(currentConversation.title)) return false;

    return currentConversation?.results.length === 0;
};
